export default {
  NONE: 'preview',
  GREENROOM: 'greenroom',
  BACKSTAGE: 'backstage',
  LIVE: 'live',
};
